const wpcf7FormRules = [
  { name: 'aninimno', target: '.hide_anonimno', showOn: (value) => value !== 'da' },
  { name: 'tveganje', target: '.show_tveganje', showOn: (value) => value === 'Da' },
  { name: 'zascita', target: '.show_zascita', showOn: (value) => value === 'Da' },
];

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wpcf7-form').forEach((form) => {
    wpcf7FormRules.forEach(({ name, target, showOn }) => {
      const radios = form.querySelectorAll(`[name="${name}"]`);
      const targetEl = form.querySelector(target);
      if (!targetEl) return;

      const update = () => {
        const checked = form.querySelector(`[name="${name}"]:checked`);
        targetEl.style.display = showOn(checked?.value) ? 'block' : 'none';
      };

      radios.forEach((r) => r.addEventListener('change', update));
      update();
    });
  });
});

// lightbox wrap
document.addEventListener('DOMContentLoaded', () => {
  const wrapImage = (img) => {
    if (img.closest('a')) return;
    const a = Object.assign(document.createElement('a'), { href: img.dataset.src || img.src });
    a.dataset.fancybox = '';
    img.replaceWith(a);
    a.append(img);
  };

  document.querySelectorAll('.editor-text img.lightbox').forEach(wrapImage);

  new MutationObserver((mutations) => {
    mutations
      .flatMap((m) => [...m.addedNodes])
      .filter((n) => n.matches?.('.editor-text img.lightbox'))
      .forEach(wrapImage);
  }).observe(document.body, { childList: true, subtree: true });

  // **************************************************

  document.querySelectorAll('.editor-text table').forEach((table) => {
    table.classList.add('mesalnice_barv');

    const wrapper = document.createElement('div');
    wrapper.classList.add('mesalnice-barv-container');

    table.parentNode.insertBefore(wrapper, table);

    wrapper.appendChild(table);
  });
});
